__webpack_require__.p = "https://enrolments-review.studyportals.eu/dist/";